module.exports = __webpack_public_path__ + "img/Youthanz.86a7bdba.png";